const rules = {
  displayFilter: 'displayFilter',
  displayTitle: 'displayTitle',
  addANewStudent: 'addAnewStudent',
};

export { rules };
